import { z } from "zod";

/**
 * Response of GET /trade-directory/users/merchant-account-status.
 *
 * The backend resolves the merchant's admin org role itself, so every merchant
 * user (auth rep, admin, director) gets the same verdict. It fails safe: if the
 * payment service is unreachable it returns `isActive: false` rather than an
 * error.
 */
export const merchantAccountStatusSchema = z.object({
  /**
   * The only field the portal gate reads. Strict boolean — a drift here would
   * silently let a merchant into the portal before the collection account
   * exists (or lock an activated one out), so log it rather than coerce it.
   */
  isActive: z.boolean(),
  /**
   * Display/debug only. Deliberately not recombined into `isActive`
   * client-side; that rule lives on the backend.
   */
  hasOnboardingCompleted: z.boolean(),
  collectionAccountActive: z.boolean(),
});

export type MerchantAccountStatus = z.infer<typeof merchantAccountStatusSchema>;
